import { ApartmentCard } from './ApartmentCard';

export type { TypeApartmentCardProps as TypeApartmentsCardProps } from './types';
export default ApartmentCard;
